export default __webpack_public_path__ + "static/media/goal1.3aeeafe4.png";